export default __webpack_public_path__ + "static/media/AvailabelRoom.82b93081.svg";